import Vue from 'vue'
import Vuex from 'vuex'
import {is_Empty} from "../utils/utils"
import VuexPersist from 'vuex-persist'
import getters from "./getters"
import state from "./state"
import mutations from "./mutations"
// 创建对象，借助浏览器缓存，存入localStorage
const vuexLocal = new VuexPersist({
    storage: window.localStorage  // 可选，sessionStorage/indexDB
})
//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
export default new Vuex.Store({
    state,
    mutations,
    getters,
    plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js